import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    FormOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import { Button, Divider, Form, Input, Modal, Table, notification } from 'antd';
import { useState } from 'react';
import IconEmpty, { IconWarning } from './iconEmpty';
import { useTranslation } from 'react-i18next';
import IconRevise from '../../../assets/Images/icons/icon-revise';
import DPIAService from '../../../services/DPIA.service';
import ModalDelete from '../../../components/Shared/modal/delete';

export default function Impact({ loading, dataSource, getDPIAImpact }) {
    const { t } = useTranslation(['translation', 'dpia']);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [error, setError] = useState('');
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [openCannot, setOpenCannot] = useState(false);

    const columns = [
        {
            title: t('Options for the impacts of data processing', {
                ns: 'dpia',
            }),
            dataIndex: 'dpiaImpactOrganizeName',
            key: 'dpiaImpactOrganizeName',
        },
        {
            title: t('Last edited by'),
            dataIndex: 'modifyBy',
            key: 'modifyBy',
            width: 300,
        },
        {
            title: t('Action'),
            dataIndex: 'status',
            key: 'status',
            width: 200,
            align: 'center',
            render: (_, record) => {
                return (
                    <div className="space-x-2">
                        <Button
                            onClick={() => {
                                form.setFieldsValue({
                                    dpiaImpactOrganizeName:
                                        record?.dpiaImpactOrganizeName,
                                    dpiaImpactOrganizeId:
                                        record?.dpiaImpactOrganizeId,
                                });
                                setIsEdit(true);
                                setOpen(true);
                            }}
                            className="bg-[#F3F6F9] text-purple-PHX border-none"
                            icon={<FormOutlined />}
                        />
                        <Button
                            onClick={() => {
                                setOpenDelete(true);
                                setDeleteId(record?.dpiaImpactOrganizeId);
                            }}
                            className="bg-[#F3F6F9] text-purple-PHX border-none"
                            icon={<DeleteOutlined />}
                        />
                    </div>
                );
            },
        },
    ];

    const setvice = (values) => {
        if (isEdit) {
            return DPIAService.updateDPIAImpact(values);
        }
        return DPIAService.createdDPIAImpact(values);
    };

    const onFinish = async (values) => {
        try {
            const { data } = await setvice(values);
            if (data?.resultCode === 1) {
                notification['success']({
                    message: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                getDPIAImpact();
                handelClose();
            }
        } catch (error) {
            if (
                error?.data?.errorData?.msg ===
                'DPIA IMPACT ORGANIZE NOT CREATE FROM SYSTEM'
            ) {
                setError(
                    t('DPIA impact organize not create from system', {
                        ns: 'dpia',
                    })
                );
            } else {
                setError(
                    t('This name is a duplicate of an existing item', {
                        ns: 'dpia',
                    })
                );
            }
        }
    };

    const handelDelete = async () => {
        try {
            const { data } = await DPIAService.deleteDPIAImpact(deleteId);
            if (data?.resultCode === 1) {
                notification['success']({
                    message: t('common.Success'),
                    description: t('Successfully to delete data'),
                });
                getDPIAImpact();
                setOpenDelete(false);
            } else {
                if (
                    data?.errorData?.msg ===
                    'This is because other DPIAs use this option.'
                ) {
                    setOpenDelete(false);
                    setOpenCannot(true);
                }
            }
        } catch (error) {
            notification['error']({
                message: t('common.Fail'),
                description: t('common.FailedDeleteData'),
            });
            console.log(error);
        }
    };

    const handelClose = () => {
        setOpen(false);
        form.resetFields();
        setError();
    };

    return (
        <div>
            <div className="text-2xl font-semibold text-purple-PHX">
                {t('Manage the options for data processing impacts', {
                    ns: 'dpia',
                })}
            </div>
            <Divider />
            <div className="font-semibold flex items-center space-x-4 justify-between mb-4">
                <div>
                    <ExclamationCircleOutlined className="text-[#F0536F] mr-2" />
                    <span>{t('Creating modifying', { ns: 'dpia' })}</span>
                </div>
                <Button
                    onClick={() => {
                        setOpen(true);
                        setIsEdit(false);
                    }}
                    size="large"
                    type="primary"
                    icon={<PlusOutlined />}
                >
                    {t('Add options', { ns: 'dpia' })}
                </Button>
            </div>
            <Table
                loading={loading}
                className="inbox_table"
                rowKey={(record, i) => i}
                dataSource={dataSource}
                columns={columns}
                scroll={{ y: 500 }}
                locale={{
                    emptyText: (
                        <div className="my-16">
                            <IconEmpty />
                            <div className="text-sm text-[#65707A] pt-2 pb-4">
                                {t('No data found')}
                            </div>
                        </div>
                    ),
                }}
                pagination={false}
            />
            <Modal
                className="_modal"
                footer={false}
                open={open}
                closable={false}
                centered
                onCancel={handelClose}
            >
                <div
                    className="text-4xl mb-6 "
                    style={{ color: '#A8A8AF', textAlign: 'center' }}
                >
                    <IconRevise />
                </div>
                <div className="text-2xl font-semibold pb-2 text-center ">
                    {t('Please read')}
                </div>
                <div className="text-center text-[#65707A] whitespace-pre-line pb-4">
                    {t(
                        'Adding or editing options affects the usability of every DPIA form page'
                    )}
                </div>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="dpiaImpactOrganizeName"
                        validateStatus={error && 'error'}
                        help={error}
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        label={t('Impact option name')}
                    >
                        <Input.TextArea
                            maxLength={250}
                            showCount
                            rows={4}
                            placeholder={t('Impact option name')}
                        />
                    </Form.Item>
                    <Form.Item name="dpiaImpactOrganizeId" hidden />
                    <div className="flex justify-center items-center space-x-4 pt-12">
                        <Button
                            className="w-36"
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                            htmlType="reset"
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button
                            className="w-36"
                            loading={loading}
                            size="large"
                            type="primary"
                            htmlType="submit"
                        >
                            {t('common.Submit')}
                        </Button>
                    </div>
                </Form>
            </Modal>
            <ModalDelete
                centered
                title={t('common.ConfirmDelete')}
                text={t(
                    'This removal affects the usability of all DPIA form pages. Be careful if this option is enabled by another DPIA',
                    { ns: 'dpia' }
                )}
                open={openDelete}
                handelOk={handelDelete}
                handelClose={() => setOpenDelete(false)}
            />
            <CannotDelete
                title={t('This item cannot be deleted')}
                text={t('This is because other DPIAs use this option')}
                open={openCannot}
                handelClose={() => setOpenCannot(false)}
            />
        </div>
    );
}

export const CannotDelete = ({ open, handelClose, title, text }) => {
    const { t } = useTranslation(['translation', 'dpia']);
    return (
        <Modal
            centered
            width={450}
            closable={false}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                <IconWarning />
                <div className="text-2xl font-semibold whitespace-pre-line">
                    {title}
                </div>
                <div className={`whitespace-pre-line text-[#65707A]`}>
                    {text}
                </div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                <Button onClick={handelClose} size="large" type="primary">
                    {t('common.Confirm')}
                </Button>
            </div>
        </Modal>
    );
};
